module.exports = __webpack_public_path__ + "static/media/avatar-12.ee9a2f1e.svg";